export var StreamerStatus;
(function (StreamerStatus) {
    StreamerStatus["New"] = "New";
    StreamerStatus["Checking"] = "Checking";
    StreamerStatus["Connected"] = "Connected";
    StreamerStatus["Disconnected"] = "Disconnected";
    StreamerStatus["NotSupported"] = "NotSupported";
    StreamerStatus["Failed"] = "Failed";
    StreamerStatus["Completed"] = "Completed";
    StreamerStatus["Closed"] = "Closed";
    StreamerStatus["Withdrawn"] = "Withdrawn";
})(StreamerStatus || (StreamerStatus = {}));
